import React from "react";
import {Grid} from "@material-ui/core";
import QuestionMark from "../../../../assets/images/q_mark.png";

class HelpDialog extends React.Component{
    render() {
        const {list}=this.props.data
        return(
            <Grid direction={"column"} item container
                className={'help-dialog'}
            >
                <Grid container alignItems={"center"} style={{position:'relative'}} justify={"center"}>
                    <Grid sm={3} xs={3} style={{position:'relative'}} alignItems={"center"} justify={"center"}>
                        <img  style={{transform: 'translateY(-25%)'}}  src={QuestionMark} alt=""/>
                    </Grid>
                    <Grid sm={6} xs={6} alignItems={"center"} justify={"center"}>
                        <p style={{color:'#ffffff',textAlign:'center'}}>
                            راهنما فصل سوم تالار جایزه پیکوپول
                        </p>
                    </Grid>
                    <Grid sm={3} xs={3} alignItems={"center"} justify={"center"}>

                    </Grid>
                    <Grid className={'help-dialog-inner'} sm={10} xs={10} alignItems={"center"} justify={"center"}>
                        {
                            list.map((data,i)=>{
                                return(
                                    <Grid className={'help-dialog-inner-section'} container alignItems={"center"} justify={"flex-start"}
                                    style={{
                                        border:`${(list.length-1)===i?'none':''}`
                                    }}>
                                        <h2>
                                            {data.title}
                                        </h2>
                                        <p>
                                            {data.text}
                                        </p>
                                    </Grid>

                                )
                            })
                        }

                            {/* <Grid className={'help-dialog-inner-section'} container alignItems={"center"} justify={"flex-start"}>*/}
                            {/*    <h2>*/}
                            {/*        چگونه بازی کنم ؟*/}
                            {/*    </h2>*/}
                            {/*    <p>*/}
                            {/*       oribus ea illum laudantium libero minus, quia quos ratione reprehenderit sequi similique tempore, vero voluptatum. Dolorum excepturi neque soluta.*/}
                            {/*    </p>*/}
                            {/*</Grid>*/}
                            {/* <Grid className={'help-dialog-inner-section'} container alignItems={"center"} justify={"flex-start"}>*/}
                            {/*    <h2>*/}
                            {/*        چگونه بازی کنم ؟*/}
                            {/*    </h2>*/}
                            {/*    <p>*/}
                            {/*       oribus ea illum laudantium libero minus, quia quos ratione reprehenderit sequi similique tempore, vero voluptatum. Dolorum excepturi neque soluta.*/}
                            {/*    </p>*/}
                            {/*</Grid>*/}

                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default HelpDialog